export const haltero_sq = require('./3_haltero.png');
export const endurence_sq = require('./3_endurance.png');
export const gym_sq = require('./3_gym.png');
